module.exports = require('./helpers/bundle-url').getBundleURL('5Hutp') + "logo-dark.eefe0b7f.svg";